import { observer } from "mobx-react-lite";
import environment from "@environment";
import Map from "@lib-shared/components/map/google-vis/map";
import MapWithMarkersStore from "@lib-shared/stores/map/map-with-markers.store";
import { RenderingType } from "@vis.gl/react-google-maps";
import mapStyles from "core/map-styles";

type BackgroundMapProps = {
  mapStore: MapWithMarkersStore;
  useAdvancedMarker?: boolean;
}

const mapConfig = environment.map;

const BackgroundMap = observer<BackgroundMapProps>((props) => {
  const { mapStore, useAdvancedMarker = false } = props;

  const renderingType = useAdvancedMarker ? RenderingType.VECTOR : RenderingType.RASTER;

  const mapId = !useAdvancedMarker
    ? undefined
    : !mapConfig.mapId ? undefined : mapConfig.mapId;

  return <>
    <Map
      apiKey={mapConfig.apiKey}
      mapId={mapId}
      onMapLoad={(map) => {
        map.setOptions({ disableDefaultUI: true });
        mapStore.updateMap(map);
      }}
      clickableIcons={false}
      defaultCenter={mapStore.center ?? mapConfig.defaultCenter}
      defaultZoom={mapConfig.defaultZoom}
      fullscreenControl={false}
      keyboardShortcuts={false}
      mapTypeControl={false}
      markers={mapStore.markers}
      renderingType={renderingType}
      rotateControl={false}
      scrollwheel={false}
      streetViewControl={false}
      styles={mapStyles}
      useAdvancedMarker={useAdvancedMarker}
      zoomControl={false}
      // markerImage={markerImage}
    />
    <div className="map-overlay"></div>
  </>
});

export default BackgroundMap;
